import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { readLivePage, readLivesPage } from "./live.server";
import { siteContext } from "./site.server";

/** Lives (/streams), for a space that has Live. Private: each live is locked or not per viewer. */
export const loadLives = createServerFn({ method: "GET" }).handler(async ({ context }) =>
  readLivesPage(await siteContext(context)),
);

/** One live (/streams/:id). */
export const loadLive = createServerFn({ method: "GET" })
  .validator((id: unknown) => {
    if (typeof id !== "string" || !/^[\w-]{1,64}$/.test(id)) throw notFound();
    return id;
  })
  .handler(async ({ data: id, context }) => readLivePage(await siteContext(context), id));
